// extracted by mini-css-extract-plugin
export default {"skeleton":"s_skeleton__afwUr","header":"s_header__8SMt3"};